import {FileUploader} from "react-drag-drop-files";
import {ReactNode, useState} from "react";

interface DefaultFileUploadProps {
    onChangeFile?: (value: File) => void;
    onSelectedPreview?: (value?: string | null) => void;
    label?: string;
    containerClassName?: string;
    children?: ReactNode;
    types: string[];
    isMultiple?: boolean;
}

export const DefaultFileUpload = ({
                                      onChangeFile = () => {
                                      },
                                      onSelectedPreview = () => {
                                      },
                                      isMultiple = false,
                                      types,
                                      children,
                                      label,
                                      containerClassName = "",
                                  }: DefaultFileUploadProps) => {
    const [preview, setPreview] = useState<string | null>(null);

    // Handle file change
    const handleChange = (file: File | File[]) => {
        if (isMultiple && Array.isArray(file)) {
            console.warn("Multiple file handling is not implemented.");
            return;
        }

        const selectedFile = Array.isArray(file) ? file[0] : file;

        // Trigger onChangeFile callback
        onChangeFile(selectedFile);

        if (selectedFile) {
            // Generate preview for the selected file
            const reader = new FileReader();
            reader.onloadend = () => {
                const filePreview = reader.result as string;
                setPreview(filePreview);
                onSelectedPreview(filePreview); // Trigger callback for preview
            };
            reader.readAsDataURL(selectedFile);
        } else {
            // Clear preview if no file is selected
            setPreview(null);
            onSelectedPreview(null);
        }
    };

    return (
        <div className={`w-full h-[150px] flex flex-col justify-between my-5 ${containerClassName}`}>
            {label && <label className="font-light text-sm block">{label}</label>}
            <FileUploader
                multiple={isMultiple}
                handleChange={handleChange}
                name="file"
                types={types.length > 0 ? types : ["JPEG", "PNG", "GIF", "JPG"]}
                classes="w-full h-full"
            >
                {children ? (
                    children
                ) : (
                    <div className="upload-bottom">
                        {preview ? (
                            <img src={preview} alt="Selected" className="w-16 h-16 object-contain"/>
                        ) : (
                            <>
                                <i className="text-5xl mt-5 bx bxs-cloud-upload"></i>
                                <div className="upload-text">
                                    <span className="span-upload-text">Click to upload</span> or drag and drop
                                    <div className="upload-text-2">
                                        SVG, PNG, JPG, or GIF (max. 800x400px)
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </FileUploader>
        </div>
    );
};
